// Shell 2027: menu lateral + header. Porta do shell.js do demo (onesalesdashboard.netlify.app),
// ligado ao markup Blade (menu/*.blade.php, aside.blade.php, header.blade.php). jQuery vem global do Metronic.
// Cada bloco é um componente em ./components; aqui só se inicializa.
const $ = window.jQuery;
const Layout = require('./components/Layout');
const Theme = require('./components/Theme');
const SidebarCollapse = require('./components/SidebarCollapse');
const SidebarNav = require('./components/SidebarNav');
const Dropdowns = require('./components/Dropdowns');
const Lia = require('./components/Lia');
const LiaFs = require('./components/LiaFs');
const SaidaDetalhe = require('./components/SaidaDetalhe');
const FilaSelecao = require('./components/FilaSelecao');
const PedidoCopiar = require('./components/PedidoCopiar');
const ChipsRolagem = require('./components/ChipsRolagem');
const FilaAbas = require('./components/FilaAbas');
const MaisFoco = require('./components/MaisFoco');
const EmailThread = require('./components/EmailThread');
const FaixaFinalizar = require('./components/FaixaFinalizar');
// D35 bloco H (J-H2): o DadosCliente (Swal "Dados do cliente") saiu; o "i" abre a 5ª janela pelo PainelOlho. O arquivo fica sem uso.
const NotaInterna = require('./components/NotaInterna');
const TelaPaineis = require('./components/TelaPaineis');
const ConversaFim = require('./components/ConversaFim');
const RolagemPropria = require('./components/RolagemPropria');
const PainelOlho = require('./components/PainelOlho');
const MenuBaixo = require('./components/MenuBaixo');
const Oportunidades27 = require('./components/Oportunidades27');

$(function () {
    Layout.init();
    Theme.init();
    SidebarCollapse.init();
    SidebarNav.init();
    Dropdowns.init();
    MenuBaixo.init();      // celular: barra de baixo (Módulos · Tickets · Alertas · Menu) e as gavetas, como o lab
    LiaFs.init();
    Lia.init();
    SaidaDetalhe.init();  // tela de tickets nova: guarda de saída do detalhe (D17b), captura em window ANTES do FilaSelecao/FilaAbas
    FilaSelecao.init();   // tela de tickets nova: item aberto da fila (aria-current)
    PedidoCopiar.init();  // tela de tickets nova: copiar código/rastreio do pedido em foco
    ChipsRolagem.init();  // tela de tickets nova: roda vertical rola os chips da linha do tempo
    FilaAbas.init();      // tela de tickets nova: abas-filtro + tempo real (D04); depois do FilaSelecao
    RolagemPropria.init(); // tela de tickets nova: barra de rolagem própria da fila e do contexto (D35 v17 G-M9b); depois do FilaAbas
    PainelOlho.init();     // tela de tickets nova: a 5ª janela (cliente, ticket, pedido; D35 bloco H); depois do FilaAbas e do RolagemPropria
    MaisFoco.init();      // tela de tickets nova: foco do teclado depois do Carregar mais / Veja mais (D07)
    EmailThread.init();   // tela de tickets nova: troca de e-mails do ticket de e-mail (D10)
    FaixaFinalizar.init(); // tela de tickets nova: botão Finalizar da faixa, com o Tipo para confirmação (D15/D23)
    NotaInterna.init();    // tela de tickets nova: "Comentário interno" na linha do tempo (D24 D); o aviso de transbordo (D24 A3) vem pelo FilaAbas
    TelaPaineis.init();    // tela de tickets nova: gaveta do contexto e painel único (D26 F2); não captura click na window (a exceção R-A mora no SaidaDetalhe)
    ConversaFim.init();    // tela de tickets nova: conversa do WhatsApp do detalhe ancorada no fim (D32)
    Oportunidades27.init(); // oportunidades-2027: liga SaidaDetalhe → FilaSelecao → PainelOlho → TelaPaineis com o mapa op-* (DD-04), na ordem acima; depois a lista
    requestAnimationFrame(() => document.body.classList.add('ui27-ready'));
});
